import ProductTelecomRequests from '../../server/productTelecom';
import { addLoading, removeLoading } from './loading';

export const getAllProductTelecom = (limit, skip, search, orderBy, field) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ProductTelecomRequests.getAllProductTelecom(limit, skip, search, orderBy, field);
  } finally {
    dispatch(removeLoading());
  }
};

export const getProductsTelecomOptions = (productId, search, loading = true) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    const dados = await ProductTelecomRequests.getProductsTelecomOptions(productId, search);
    return dados;
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const getResultFormulaProduct = (id, meters, points, loading = true) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    const dados = await ProductTelecomRequests.getResultFormulaProduct(id, meters, points);
    return dados;
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const createProductTelecom = newProductTelecom => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ProductTelecomRequests.createProductTelecom(newProductTelecom);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateProductTelecom = updProductTelecom => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ProductTelecomRequests.updateProductTelecom(updProductTelecom);
  } finally {
    dispatch(removeLoading());
  }
};
